import { render, staticRenderFns } from "./JurisdictionPage.vue?vue&type=template&id=1dd9f2c5"
import script from "./JurisdictionPage.vue?vue&type=script&lang=js"
export * from "./JurisdictionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports